
// 校验密码
export const validatePass = (rule, value, callback) => {
    if (!value) {
        callback(new Error('密码为必填'));
    } else {
        const regex = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*]).+$/;
        if(/\s/.test(value)){   // 如果包含空格
            callback(new Error('密码不能有空格'));
        }else{
            if(/[\u4e00-\u9fff]/.test(value)){  // 不能有中文
                callback(new Error('密码不能有中文'));
            }else{
                if (regex.test(value)) {
                    callback();
                } else {
                    console.log(value.length);
                    if (value.length < 6 || value.length > 30) {
                        callback(new Error('密码长度6~30'));
                    } else {
                        callback(new Error('密码至少包含一个数字，大、小写字母，及以下特殊字符（!、@、#、$、%、^、&、*）'));
                    }
                }
            }

        }
    }
};

// 校验不同验证方式下
// export  const  validateValidateWay = (rule, value, callback)=>{
//     if (!value) {
//         callback(new Error('密码为必填'));
//     } else {
//         const regex = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*]).+$/;
//         if(/\s/.test(value)){   // 如果包含空格
//             callback(new Error('密码不能有空格'));
//         }else{
//             if(/[\u4e00-\u9fff]/.test(value)){  // 不能有中文
//                 callback(new Error('密码不能有中文'));
//             }else{
//                 if (regex.test(value)) {
//                     callback();
//                 } else {
//                     if (value.length < 6 || value.length > 30) {
//                         callback(new Error('密码长度6~30'));
//                     } else {
//                         callback(new Error('密码至少包含一个数字，大、小写字母，及以下特殊字符（!、@、#、$、%、^、&、*）'));
//                     }
//                 }
//             }
//
//         }
//     }
// }


// 手机号验证
export const  validatePhoneNumber = function(phoneNumber) {
    // 定义手机号正则表达式
    const phoneRegex = /^1[3456789]\d{9}$/;

    // 使用test方法检查手机号是否符合格式
    if (phoneRegex.test(phoneNumber)) {
        console.log('手机号格式正确');
        return true;
    } else {
        console.log('手机号格式错误');
        return false;
    }
}


// 验证邮箱
export const  validateEmail = function(email) {
    const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
    return regEmail.test(email);
}
